import React from "react";
import { Box } from "@mui/material";

// component="main" gives screen readers (JAWS/NVDA) a landmark to jump straight to the page content
// tabIndex -1 lets focus be sent here programmatically (e.g. when a dialog closes with no opener)
const MainContentWrapper = ({ children, maxWidth = "1180px" }) => (
  <Box
    component="main"
    id="conteudo-principal"
    tabIndex={-1}
    sx={{ margin: 0, padding: 0 }}
  >
    <Box sx={{ maxWidth, margin: "0 auto" }}>{children}</Box>
  </Box>
);

export default MainContentWrapper;
